export default __webpack_public_path__ + "static/media/current-icon.2b161578.svg";